<template>
    <v-card rounded flat color="white" class="fill-height" style="overflow: hidden">
        <v-card-text class="fill-height" style="overflow-y: auto" ref="list">
            <v-row class="ma-n4">
                <template v-for="(message, index) in messages">
                    <messages-item v-bind="{ index, message, isScrollFixed }" v-on="{ scroll }" :key="index" />
                </template>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import MessagesItem from "./messages/messages-item.vue";

export default {
    components: {
        MessagesItem,
    },
    data: () => ({
        isInitiated: false,
        isScrollFixed: true,
    }),
    computed: {
        ...mapGetters("chat", ["messages"]),
    },
    methods: {
        init() {
            if (!this.isInitiated) {
                const intervalId = setInterval(() => {
                    const el = this.$refs["list"]?.$el;
                    if (!el) return;

                    el.addEventListener("scroll", this.onScroll);
                    el.scrollTop = el.scrollHeight;
                    this.isInitiated = true;

                    clearInterval(intervalId);
                }, 10);
            }
        },
        onScroll(event) {
            const { scrollHeight, scrollTop, clientHeight } = event.target;
            this.isScrollFixed = scrollHeight - (scrollTop + clientHeight) < 30;
        },
        scroll() {
            const el = this.$refs["list"];
            if (!el) return;
            el.scrollTo({ top: el.scrollHeight });
        },
    },
    watch: {
        isInitiated() {
            this.$nextTick(this.scroll);
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style>
</style>